 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-Connect-vue":"view-Connect-vue","view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue":"view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue","view-InitLoadingHistory-vue":"view-InitLoadingHistory-vue","view-TradeHistory-vue":"view-TradeHistory-vue","view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue":"view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue","view-Login-vue":"view-Login-vue","view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue":"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue","view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue":"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue","view-InitLoadingMain-vue":"view-InitLoadingMain-vue","view-Main-vue":"view-Main-vue","view-Mypage-vue":"view-Mypage-vue","view-Staking-vue~view-Trading-vue":"view-Staking-vue~view-Trading-vue","view-Staking-vue":"view-Staking-vue","view-Trading-vue":"view-Trading-vue","view-NotFound-vue":"view-NotFound-vue"}[chunkId]||chunkId) + "." + {"view-Connect-vue":"44a43a24","view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue":"2e1a9c86","view-InitLoadingHistory-vue":"37a5326b","view-TradeHistory-vue":"8e21d68f","view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue":"1c31a1d9","view-Login-vue":"98a96d95","view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue":"be66cbde","view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue":"f03d695c","view-InitLoadingMain-vue":"77e9079b","view-Main-vue":"7d6f4671","view-Mypage-vue":"85a689dd","view-Staking-vue~view-Trading-vue":"9e174c25","view-Staking-vue":"a090cd66","view-Trading-vue":"9876341f","view-NotFound-vue":"a14fa01e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-Connect-vue":1,"view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue":1,"view-InitLoadingHistory-vue":1,"view-TradeHistory-vue":1,"view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue":1,"view-Login-vue":1,"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue":1,"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue":1,"view-InitLoadingMain-vue":1,"view-Main-vue":1,"view-Mypage-vue":1,"view-Staking-vue~view-Trading-vue":1,"view-Staking-vue":1,"view-Trading-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-Connect-vue":"view-Connect-vue","view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue":"view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue","view-InitLoadingHistory-vue":"view-InitLoadingHistory-vue","view-TradeHistory-vue":"view-TradeHistory-vue","view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue":"view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue","view-Login-vue":"view-Login-vue","view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue":"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue","view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue":"view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue","view-InitLoadingMain-vue":"view-InitLoadingMain-vue","view-Main-vue":"view-Main-vue","view-Mypage-vue":"view-Mypage-vue","view-Staking-vue~view-Trading-vue":"view-Staking-vue~view-Trading-vue","view-Staking-vue":"view-Staking-vue","view-Trading-vue":"view-Trading-vue","view-NotFound-vue":"view-NotFound-vue"}[chunkId]||chunkId) + "." + {"view-Connect-vue":"b9db722c","view-InitLoadingHistory-vue~view-InitLoadingMain-vue~view-Main-vue~view-TradeHistory-vue":"5f827e71","view-InitLoadingHistory-vue":"7e68b827","view-TradeHistory-vue":"cedd70e2","view-InitLoadingMain-vue~view-Login-vue~view-Main-vue~view-Trading-vue":"50af88d6","view-Login-vue":"203e6407","view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Staking-vue":"3cae498a","view-InitLoadingMain-vue~view-Main-vue~view-Mypage-vue~view-Trading-vue":"d25dd1b4","view-InitLoadingMain-vue":"9b62052b","view-Main-vue":"41ff51a4","view-Mypage-vue":"fe84e274","view-Staking-vue~view-Trading-vue":"2e0d4e29","view-Staking-vue":"232d2948","view-Trading-vue":"f19fb60a","view-NotFound-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
